import React from "react";
import { ConfigProvider, Table } from "antd";

const TableModal = (props) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: '#354A55',
            headerColor: '#fff',
            borderColor: '#fff'
          },
        },
      }}
    >
      <Table
        dataSource={props.rows}
        columns={props.columns}
        pagination={false}
        size="small"
        scroll={{ x: 950, y: "calc(85vh - 220px)" }}
      />
    </ConfigProvider>
  );
};

export default TableModal;
